/**
 * Whether opening an artifact should widen the dock, and to what (APP-3443). Pure, so the arithmetic is testable
 * with literals on both sides of the threshold — the policy the host applies around it (who owns the width, what
 * is handed back) lives in `kelly-dock.tsx`.
 */

import { dockWidthCeiling } from "./dock-metrics"
import { SIDE_BY_SIDE_MIN_AREA_PX } from "./panel-metrics"

/** The dock's own left border sits outside the chat area (border-box), so the area is a pixel narrower. */
const DOCK_BORDER_PX = 1

/**
 * The narrowest dock whose chat area seats an artifact BESIDE the conversation. The container query is
 * `max-width: SIDE_BY_SIDE_MIN_AREA_PX`, so the area has to exceed it rather than meet it — hence the second +1.
 * 744 + 1 + 1 = 746. Asserted against real layout in `kelly-dock.stories.tsx`, not just derived here.
 */
export const SIDE_BY_SIDE_MIN_DOCK_WIDTH_PX = SIDE_BY_SIDE_MIN_AREA_PX + DOCK_BORDER_PX + 1

/**
 * The width to widen to when an artifact opens, or `null` for "leave it alone".
 *
 * Null in two cases, and the first is the one worth stating: **a display whose ceiling cannot reach the
 * threshold is a no-op, never a partial widen.** On a 1280px screen the 45% ceiling is 576px; widening to 576
 * would take 184px off the page and still overlay the artifact, so the user pays the reflow for nothing.
 */
export function artifactDockWidth(currentWidth: number, viewportWidth: number): number | null {
  if (dockWidthCeiling(viewportWidth) < SIDE_BY_SIDE_MIN_DOCK_WIDTH_PX) return null
  if (currentWidth >= SIDE_BY_SIDE_MIN_DOCK_WIDTH_PX) return null
  return SIDE_BY_SIDE_MIN_DOCK_WIDTH_PX
}
